export const appHead = {"meta":[{"name":"viewport","content":"width=device-width, initial-scale=1"},{"charset":"utf-8"},{"name":"robots","content":"noindex,nofollow"}],"link":[{"rel":"icon","type":"image/x-icon","href":"https://assets.cambridgeone.org/dashboard2023/_nuxt/favicon.ico"},{"rel":"preconnect","href":"https://assets.cambridgeone.org/"}],"style":[],"script":[{"src":"https://assets.cambridgeone.org/dashboard2023/newrelic-script-v1.295.0.js","defer":true,"type":"text/javascript"}],"noscript":[],"title":"Cambridge One | Cambridge University Press","htmlAttrs":{"lang":"en"}}

export const appRootAttrs = {"id":"__nuxt","aria-live":"polite"}

export const appCdnURL = "https://assets.cambridgeone.org/dashboard2023"

export const appBaseURL = "/dashboard/"

export const appBuildAssetsDir = "/_nuxt/"

export const appLayoutTransition = false

export const appPageTransition = false

export const appViewTransition = false

export const appKeepalive = false

export const appRootId = "__nuxt"

export const appRootTag = "div"

export const appTeleportTag = "div"

export const appTeleportId = "teleports"

export const appTeleportAttrs = {"id":"teleports"}

export const appSpaLoaderTag = "div"

export const appSpaLoaderAttrs = {"id":"__nuxt-loader"}

export const renderJsonPayloads = true

export const componentIslands = false

export const payloadExtraction = false

export const cookieStore = true

export const appManifest = false

export const remoteComponentIslands = false

export const selectiveClient = false

export const devPagesDir = null

export const devRootDir = null

export const devLogs = false

export const nuxtLinkDefaults = {"componentName":"NuxtLink","prefetch":true,"prefetchOn":{"visibility":true}}

export const asyncDataDefaults = {"deep":false}

export const fetchDefaults = {}

export const vueAppRootContainer = '#__nuxt'

export const viewTransition = false

export const appId = "nuxt-app"

export const outdatedBuildInterval = 3600000

export const multiApp = false

export const chunkErrorEvent = "vite:preloadError"

export const crawlLinks = false

export const spaLoadingTemplateOutside = true

export const purgeCachedData = true

export const granularCachedData = true

export const pendingWhenIdle = false

export const alwaysRunFetchOnKeyChange = false